<div class="btn-toolbar">
    <!-- Dates dropdown -->
    <div ngbDropdown class="d-inline-block btn-group mr-1">
        <!-- dropdown trigger -->
        <button class="btn"
                [class.btn-outline-secondary]="!SelectedDate"
                [class.btn-primary]="SelectedDate"
                type="button"
                ngbDropdownToggle
                [disabled]="DatesList.length == 1">
            <i class="fa fa-calendar"></i>
            {{TitleLabel}}
        </button>
        <!-- dropdown menu -->
        <div ngbDropdownMenu>
            <div class="btn-group btn-group-toggle pl-2 pr-2">
                <ng-container *ngFor="let date of DatesList">
                    <label class="btn-light" ngbButtonLabel>
                        <input type="checkbox" ngbButton [ngModel]="SelectedDate == date" (ngModelChange)="didTapDate(date)"> {{ date.toFormat('dd') }} <br />
                        <small *ngIf="!isTodayDate(date)" class="text-muted">{{ date.toFormat('MMM')}}</small>
                        <small *ngIf="isTodayDate(date)" class="text-danger">{{ 'LBL.TODAY' | translate}}</small>
                    </label>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Close button -->
    <div class="btn-group" *ngIf="SelectedDate">
        <button type="button" class="btn btn-primary" (click)="didClearSelection()" ><i class="fas fa-times-circle"></i></button>
    </div>
</div>
